let ga4Loaded = false;
let analyticsConsentGranted = false;

export const setGa4Loaded = () => {
  ga4Loaded = true;
};

export const isGa4Loaded = () => ga4Loaded;

export const setAnalyticsConsentGranted = (granted: boolean) => {
  analyticsConsentGranted = granted;
};

export const isAnalyticsConsentGranted = () => analyticsConsentGranted;
